import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import HomePage from '@/components/home/HomePage.vue'
import Communities from '@/components/community/Communities.vue'
import Community from './components/community/Community.vue'
import PersoInfo from '@/components/user/PersoInfo.vue'
import Unauthorized from '@/components/error/Unauthorized.vue'
import ReadAbout from '@/components/legal/ReadAbout.vue'
import GeneralCondition from '@/components/legal/GeneralCondition.vue'
import HealthPage from '@/components/Health.vue'
import BrowserSupport from '@/components/error/BrowserSupport.vue'
import PostPage from '@/components/post/PostPage'
import AdministratorPage from '@/components/administrator/AdministratorPage'
import NotFound from '@/components/error/NotFound'
import Dashboard from '@/components/dashboard/Dashboard'
import TestMetadataPage from './components/administrator/TestMetadataPage'
import InterestList from './components/administrator/InterestList'
import AnonymisationPage from './components/administrator/AnonymisationPage'
import ConfigPage from './components/administrator/ConfigPage'
import ReportedCommunities from './components/administrator/ReportedCommunities'
import ReportedContents from './components/administrator/ReportedContents'
// eslint-disable-next-line no-unused-vars
import Bowser from 'bowser'

// const browser = Bowser.getParser(window.navigator.userAgent)
// const supportedBrowser = ['Chrome']
// const isSupportedBrowser = () => (browser && supportedBrowser.includes(browser.getBrowserName()))

const isSupportedBrowser = () => true

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'homePage',
    component: HomePage,
    meta: { noAuth: false },
    default: true
  },
  {
    path: '/administrator',
    name: 'administratorPage',
    redirect: '/administrator/reportedCommunities',
    component: AdministratorPage,
    meta: { noAuth: false, administrator: true },
    children: [
      { path: 'reportedCommunities', component: ReportedCommunities },
      { path: 'reportedContents', component: ReportedContents },
      { path: 'interests', component: InterestList },
      { path: 'config', component: ConfigPage },
      { path: 'anonymise', component: AnonymisationPage },
      { path: 'testMetadatas', component: TestMetadataPage }
    ]
  },
  {
    path: '/communities',
    name: 'communitiesPage',
    component: Communities,
    meta: { noAuth: false }
  },
  {
    path: '/community/:id',
    name: 'communityPage',
    component: Community,
    meta: { noAuth: false },
    props: true
  },
  {
    path: '/posts/:id',
    name: 'postPage',
    component: PostPage,
    meta: { noAuth: false },
    props: true
  },
  {
    path: '/users/:id',
    name: 'userInfo',
    component: PersoInfo,
    meta: { noAuth: false },
    props: true
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: Unauthorized,
    meta: { noAuth: true }
  },
  {
    path: '/:component/not-found',
    name: 'notFound',
    component: NotFound,
    meta: { noAuth: false },
    props: true
  },
  {
    path: '/about',
    name: 'about',
    component: ReadAbout,
    meta: { noAuth: false }
  },
  {
    path: '/dashboard',
    name: 'dashboardPage',
    component: Dashboard,
    meta: { noAuth: false, administrator: true }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: GeneralCondition,
    meta: { noAuth: false }
  },
  {
    path: '/browsersupport',
    name: 'browsersupport',
    component: BrowserSupport,
    meta: { noAuth: true }
  },
  {
    path: '/health',
    name: 'healthPage',
    component: HealthPage,
    meta: { noAuth: true }
  }
]

const router = new Router({
  routes: routes,
  mode: 'history',
  history: true,
  base: '/',
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

const proceedToNextPage = (to, next) => {
  next()
}

const detectAuthenticationCode = async (to, next) => {
  if (to.query.session_state != null && to.query.code !== '') {
    const authenticated = await store.dispatch('authenticateByCode', to.query.code)
    if (authenticated) {
      // Redirect user to home page without code in url. Could redirect to 'to'
      router.push('/home')
    } else {
      next({ name: 'unauthorized' })
    }
    return false
  }
  return true
}

router.beforeEach(async (to, from, next) => {
  if (!isSupportedBrowser()) {
    if (to.fullPath !== '/browsersupport') {
      router.replace({
        name: 'browsersupport'
      })
    }
    proceedToNextPage(to, next)
    return
  }
  if (!(await detectAuthenticationCode(to, next))) {
    return
  }
  if (to.name === 'unauthorized') {
    // Do nothing cause no before on unauthorized
    proceedToNextPage(to, next)
    return
  }
  store.commit('closePanel')
  store.commit('activeRoute', to)
  if (store.getters.currentUserId) {
    proceedToNextPage(to, next)
  } else { // There's been a refresh
    try {
      const authenticated = await store.dispatch('authenticate')
      if (authenticated) {
        if (!store.getters.user.agreement) {
          // keep targeted url as a redirect param after agreement is given
          await router.replace({ name: 'agreement' })
        } else {
          proceedToNextPage(to, next)
        }
      } else {
        // keep targeted url as a redirect param after login
        await store.dispatch('redirectToAuthWorkflow')
        // next({ name: 'unauthorized' })
      }
    } catch (e) {
      if (e.name === 'UnauthorizedError') {
        // specific error
      } else {
        throw e // let others bubble up
      }
    }
  }
})

export default router
